import { render, staticRenderFns } from "./workloginfo-preset.vue?vue&type=template&id=7e36bf94&scoped=true&"
import script from "./workloginfo-preset.vue?vue&type=script&lang=js&"
export * from "./workloginfo-preset.vue?vue&type=script&lang=js&"
import style0 from "./workloginfo-preset.vue?vue&type=style&index=0&id=7e36bf94&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e36bf94",
  null
  
)

export default component.exports